import { Measurement } from './_types';

export const LIB_MEASURES_HARVEST_DISEASE : Measurement[] = [

    {
        id: "frut_disease_shrivel",
        unit: "%",
        label: "Shrivel Severity",
        tag: "SHR",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_disease_shri_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_disease",
    },
    {
        id: "frut_disease_bruising",
        unit: "%",
        label: "Bruising Severity",
        tag: "BRU",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_disease_bru_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_disease",
    },
    {
        id: "frut_disease_gel_breakdown",
        unit: "%",
        label: "Gel Breakdown Severity",
        tag: "GEL",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_disease_gel_br_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_disease",
    },
    {
        id: "frut_internal_browning",
        unit: "%",
        label: "Internal Browning Severity",
        tag: "INB",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_internal_brown_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_disease",
    },
    {
        id: "frut_inking",
        unit: "%",
        label: "Inking Severity",
        tag: "INK",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_inking_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_disease",
    },
    {
        id: "frut_sugar_spots",
        unit: "%",
        label: "Sugar Spots Severity",
        tag: "SUS",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_sugar_spots_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_disease",
    },
    {
        id: "frut_stem_decay",
        unit: "%",
        label: "Stem Decay Severity",
        tag: "STE",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_stem_decay_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_disease",
    },

]